export default "__VITE_ASSET__0962cd4e__"